import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Store references for logout functionality
let logoutCallback = null;
let navigationCallback = null;

// Setup interceptor callbacks
export const setupApiInterceptors = (logout, navigate) => {
  logoutCallback = logout;
  navigationCallback = navigate;
};

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // First check for integration token in URL query params
    const urlParams = new URLSearchParams(window.location.search);
    const integrationToken = urlParams.get('token');

    if (integrationToken) {
      // For integration access, append token to the request URL as query param
      const separator = config.url.includes('?') ? '&' : '?';
      config.url = `${config.url}${separator}token=${integrationToken}`;
    } else {
      // Use regular auth token from localStorage
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Check if using integration token - don't redirect to login
      const urlParams = new URLSearchParams(window.location.search);
      const integrationToken = urlParams.get('token');

      if (integrationToken) {
        // For integration access, just reject with error message
        return Promise.reject(new Error('Integration token expired or invalid.'));
      }

      // Session expired or invalid token
      console.log('Session expired, redirecting to login...');

      // Clear stored authentication data
      localStorage.removeItem('token');
      localStorage.removeItem('teacher');

      // Call logout callback if available
      if (logoutCallback) {
        logoutCallback();
      }

      // Navigate to login if callback available
      if (navigationCallback) {
        navigationCallback('/login', { replace: true });
      }

      // Return a rejected promise with a user-friendly message
      return Promise.reject(new Error('Session expired. Please log in again.'));
    }

    return Promise.reject(error);
  }
);

// API functions
export const calculateLexileLevel = async (text) => {
  console.log('🌐 API CALL - calculateLexileLevel with text length:', text.length);
  try {
    const response = await api.post('/api/passages/calculate-lexile', { text });
    console.log('🌐 API RESPONSE - calculateLexileLevel:', response.data);
    return response.data.lexileLevel;
  } catch (error) {
    console.error('🌐 API ERROR - calculateLexileLevel:', error);
    console.error('🌐 API ERROR - Response data:', error.response?.data);
    throw error;
  }
};

// Export the configured axios instance
export default api;